import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const FormattedMessageWithClass = props => (
  <FormattedMessage {...props}>
    {(txt) => (
      <span className={props.className}>
        {txt}
      </span>
    )}
  </FormattedMessage>
);

export default injectIntl(FormattedMessageWithClass, {
  withRef: false
});



// WEBPACK FOOTER //
// ./util/IntlMessages.js